import React from "react";
import { NumericFormat } from "react-number-format";
import { useField } from "formik";
import { Form } from "react-bootstrap";

export default function NumberField(props) {
    const { name, label, isNameLoading = false, validatedName = "", controlId, ...rest } = props;
    const [field, meta] = useField(name);
    // const { setValue } = helpers;

    return (
        <Form.Group controlId={controlId}>
            <Form.Label>{label}</Form.Label>
            <NumericFormat
                {...field}
                {...rest}
                customInput={Form.Control}
                thousandSeparator={false}
                autoComplete="off"
                className={meta.error && meta.touched && "border border-danger"}
            />
            {meta.error && meta.touched ? (
                <small className="text-danger">{meta.error}</small>
            ) : null}
            {isNameLoading && <span className="text-warning">Verifying account name...</span>}
            {!isNameLoading && validatedName && <div className="text-success">{validatedName}</div>}
        </Form.Group>
    );
}
